/**
 * @description 保存cookie
 * @param {Object} json 需要存储cookie的对象
 * @param {Number} days 默认存储多少天
 */
function setCookie(json, seconds) {
  // 设置过期时间
  let data = new Date(
    new Date().getTime() + seconds * 1000
  ).toUTCString();

  for (var key in json) {
    document.cookie = key + "=" + json[key] + "; expires=" + data;
  }
}

/**
 * @description 获取cookie
 * @param {String} name 需要获取cookie的key
 */
function getCookie(name) {
  var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
  if (arr != null) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

/**
 * @description 删除cookie
 * @param {String} name 需要删除cookie的key
 */
function clearCookie(name) {
  let json = {};
  json[name] = "";
  setCookie(json, -1);
}


/**
 * @description 获取嵌套的cookie
 * @param {String} cookieName 需要获取cookie的key
 * @param {String} nestedKey 需要获取的嵌套key
 */

function getNestedCookie(cookieName, nestedKey) {
  const cookieValue = getCookie(cookieName);
  if (!cookieValue) return null;
  try {
    const parsedData = JSON.parse(cookieValue);
    return parsedData[nestedKey] || null;
  } catch (e) {
    console.error("Failed to parse cookie JSON:", e);
    return null;
  }
}


/**
 * 更新嵌套 Cookie 的某个字段
 * @param {string} cookieName  Cookie 名称（如 "session"）
 * @param {string} nestedKey   嵌套字段（如 "displayName"）
 * @param {any} newValue       新值
 */
function updateNestedCookie(cookieName, nestedKey, newValue) {
  const cookieValue = getCookie(cookieName);
  if (!cookieValue) return false;
  try {
    const data = JSON.parse(cookieValue);
    data[nestedKey] = newValue;
    setCookie({ [cookieName]: JSON.stringify(data) }, 3 * 60 * 60);
    return true;
  } catch (e) {
    console.error(`更新 ${cookieName}.${nestedKey} 失败:`, e);
    return false;
  }
}


export default {
  setCookie,
  getCookie,
  clearCookie,
  getNestedCookie,
  updateNestedCookie
};



// WEBPACK FOOTER //
// ./src/utils/cookie.js